import Client from '@/services/client.js'

export default {
  install(Vue) {
    Vue.prototype.$client = Client
  }
}
